import { DialogContent, DialogTitle } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { skillMaps } from "routes/skill-mapper/controller/skill-maps"
import { useUniqueNameValidator } from "../use-unique-name-validation"

export function SkillMapRenameDialog({ currentId, name }) {
    // status:"all" so the duplicate-name check matches the server (which counts archived too).
    const result = skillMaps.useResults({ skip: 0, take: 1000, status: "all" })
    const validateName = useUniqueNameValidator(result?.items, "skill mapping", { excludeId: currentId })
    return (
        <DataInputDialog initialValue={{ name: name || "" }} okCaption="Rename" startValid>
            <DialogTitle sx={{ pb: 3 }}>Rename Skill Map</DialogTitle>
            <DialogContent>
                <BoundTextField field="name" label="Name" yup={validateName} autoFocus fullWidth sx={{ mt: 1 }} />
            </DialogContent>
        </DataInputDialog>
    )
}
